var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgIconLoginman(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 40,
    viewBox: "0 0 37 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.a{stroke:#fff;stroke-width:2px;}.b{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-935.742 -258.104)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(942.742 258.104)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 11,
    cy: 11,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 11,
    cy: 11,
    r: 10
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(935.742 280.104)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18,0h1A18,18,0,0,1,37,18v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A18,18,0,0,1,18,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M16.2,1h4.6A15.2,15.2,0,0,1,36,16.2v0a.8.8,0,0,1-.8.8H1.8a.8.8,0,0,1-.8-.8v0A15.2,15.2,0,0,1,16.2,1Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoginman);
export default __webpack_public_path__ + "static/media/icon-loginman.d8e2cb6cc0da0f836bf3a10856db2a79.svg";
export { ForwardRef as ReactComponent };